import axios from 'axios'
import { appConfig } from 'Config/app-config'
import { getBearerToken } from 'shared/auth/auth.utils'

export const ExpertsClient = axios.create({
    baseURL: appConfig.expertsApiBaseUrl,
    headers: {
        'X-Caller-Service': 'experts-client',
    },
})

ExpertsClient.interceptors.request.use(
    config => {
        const token = getBearerToken()
        if (token) {
            config.headers['Authorization'] = token
        }
        return config
    },
    error => {
        return Promise.reject(error)
    }
)
